import React from 'react'
import Bundle from './Bundle';
import Loading from 'widget/Loading/Loading';

//懒加载
export const createBundle = (component,pageType="") => () => (
  <Bundle load={component} pageType={pageType}>
    {
      (Component) => Component ? <Component/> : <Loading/>
    }
  </Bundle>
);


// WEBPACK FOOTER //
// ./src/widget/Common/index.js